export const pageSizesType: Record<string, { x: number; y: number }> = {
  A5: { x: 148, y: 210 },
  A4: { x: 210, y: 297 },
  A3: { x: 297, y: 420 },
  B5: { x: 176, y: 250 },
  B4: { x: 250, y: 353 },
  'JIS-B5': { x: 182, y: 257 },
  'JIS-B4': { x: 257, y: 364 },
  letter: { x: 216, y: 279 },
  legal: { x: 216, y: 356 },
  ledger: { x: 355.6, y: 431.8 },
};

export const pageTypeSizes: Record<string, string> = {
  Custom: 'Custom',
  A5: 'A5',
  A4: 'A4',
  A3: 'A3',
  B5: 'B5',
  B4: 'B4',
  'JIS-B5': 'JIS-B5',
  'JIS-B4': 'JIS-B4',
  letter: 'letter',
  legal: 'legal',
  ledger: 'ledger',
};

export const pageTypeSizeOptions = Object.keys(pageTypeSizes).map((key) => ({
  value: pageTypeSizes[key],
  label: key === pageTypeSizes['Custom'] ? 'Customizado' : pageTypeSizes[key],
}));
